import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

constructor(private http:HttpClient) { }

  Login_Action(username:string,password:string,hash:string,code:string,browser:string):Observable<any>{
    const body = {
      username: username,
      password:password,
      fname:hash,
      lname:code,
      create_username:browser
    };

    return this.http.post(environment.BaseUrl +"Daro/Login",body).pipe(
      map(data=>{
        return data
      })
    )
  }

  ResetPassword(OldPassowrd:string,NewPassword:string,Token:string):Observable<any>{
    const body = {
      password: OldPassowrd,
      username:Token,
      create_username:NewPassword
    };

    return this.http.post(environment.BaseUrl +"Daro/Login/ResetPassword",body).pipe(
      map(data=>{
        return data
      })
    )
  }

  MustChangePassword(NewPassword:string,Token:string):Observable<any>{
    const body = {
      username:Token,
      create_username:NewPassword
    };

    return this.http.post(environment.BaseUrl +"Daro/Login/MustChangePassword",body).pipe(
      map(data=>{
        return data
      })
    )
  }


  GetUserRole(token:string):Observable<any>{


    return this.http.get(environment.BaseUrl +"Daro/Login/GetUserRole?token="+token).pipe(
      map(data=>{
        return data
      })
    )
  }

  RestCapcha(oldfile:string):Observable<any>{


    return this.http.get(environment.BaseUrl +"Daro/Login/RestCapcha?oldfile="+oldfile).pipe(
      map(data=>{
        return data
      })
    )
  }

  Exit(token:string):Observable<any>{


    return this.http.get(environment.BaseUrl +"Daro/Login/Exit?token="+token).pipe(
      map(data=>{
        return data
      })
    )
  }


  AutoLogin(token:string,id:number):Observable<any>{
    return this.http.get(environment.BaseUrl +"Daro/Login/AutoLogin?token="+token
    +"&id="+id).pipe(
      map(data=>{
        return data
      })
    )
  }

  GetTokenStation(token:string):Observable<any>{
    return this.http.get(environment.BaseUrl +"Daro/Login/GetTokenStation?token="+token).pipe(
      map(data=>{
        return data
      })
    )
  }


  ExtensionTokenStation(token:string):Observable<any>{
    return this.http.get(environment.BaseUrl +"Daro/Login/ExtensionTokenStation?token="+token).pipe(
      map(data=>{
        return data
      })
    )
  }

  SubmitUrl(link:string,Token:string):Observable<any>{
    return this.http.get(environment.BaseUrl +"Daro/Login/SubmitUrl?token="+Token+"&link="+link).pipe(
      map(data=>{
        return data
      })
    )
  }

}
